<template>
    <div class="g-container-box">
        <el-row class="g-header-container">
            <el-col :span="3">
                <div class="g-header-left">熟客控制台</div>
            </el-col>
            <el-col :span="16">
                <nav-head navSel="1"></nav-head>
            </el-col>
            <el-col :span="5">
                <op-head></op-head>
            </el-col>
        </el-row>
        <el-row class="g-view-container">
            <el-col :span="3" class="g-menu-container">
                <sidebar navType="2" defaultSel="3"></sidebar>
            </el-col>
            <el-col :span="21" class="g-center-container">
                <el-table :data="listData" style="width: 100%">
                    <el-table-column prop="time" label="时间"></el-table-column>
                    <el-table-column prop="enrollment" label="注册用户数"></el-table-column>
                    <el-table-column prop="shop" label="入住门店数"></el-table-column>
                    <el-table-column prop="merchant" label="入住电商数"></el-table-column>
                    <el-table-column prop="uv" label="日均访客数（UV）"></el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>
  
<script>
var util = require("@/common/util.js");
import { API_USERTOJ } from "../../assets/js/api.js";
import sidebar from '../../components/sidebar'
import navHead from "../../components/navHead";
import opHead from "../../components/opHead.vue";
export default {
    components: {
        sidebar,
        navHead,
        opHead
    },
    data() {
        return {
            listData: [],
            dialog: false,
            name: '',
            wxName: ''
        }
    },
    created() {
        this.getListData()
    },
    methods: {
        getListData() {
            let params = {}
            util.getData(API_USERTOJ, params, (res) => {
                for(let i=0; i<=res.data.data.length; i++){
                    this.listData.push(res.data.data[i])
                }

                this.listData[0].time = '合计'
                this.listData[1].time = '昨天'
                this.listData[2].time = '一周内'
                this.listData[3].time = '近30天'
            })
        }
    }
}
</script>
  
<style lang="less">
.g-container-box {
    overflow: hidden;
}

.g-header-left {
    background-color: #5c6be8;
    color: #FFF;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.g-menu-container {
    height: 800px;
    background-color: #fff;
}
.g-center-container {
    overflow: auto;
    height: 800px;
    background-color: #eff3f6;
    padding: 20px;
}

.nav_search {
    margin-top: 10px;
    margin-bottom: 30px;
}

.order_input1 {
    margin-bottom: 20px;
}</style>


// WEBPACK FOOTER //
// src/pages/glyYhtj/index.vue